import React from "react";
import { useIntl } from "react-intl";
import { Typography, Tooltip } from "antd";

import colors from "../../../colors";
import LoadTable from "../../app/generic/loadTable";
import StateIcon from "../../app/generic/stateIcon";
import CustomIcon from "../../app/generic/customIcon";

const { Text } = Typography;

function InvoiceListTable({
  invoices,
  loadInvoices,
  selectedInvoices,
  setSelectedInvoices,
}) {
  const intl = useIntl();
  const columns = [
    {
      key: "state",
      title: intl.formatMessage({
        id: "invoice.state",
        defaultMessage: "Stav",
      }),
      dataIndex: "state",
      width: 60,
      className: "center",
      render: (state) =>
        state === "PA" ? (
          <StateIcon
            valid
            messages={[
              intl.formatMessage({
                id: "invoice.paid",
                defaultMessage: "Faktura byla zaplacena",
              }),
            ]}
          />
        ) : state === "CA" ? (
          <CustomIcon
            type="close"
            title={intl.formatMessage({
              id: "invoice.cancelled",
              defaultMessage: "Faktura byla stornována",
            })}
          />
        ) : state === "CN" ? (
          <CustomIcon
            type="rollback"
            title={intl.formatMessage({
              id: "invoice.creditNote",
              defaultMessage: "dobropis",
            })}
          />
        ) : (
          <CustomIcon
            type="warning"
            color={colors.YELLOW}
            title={intl.formatMessage({
              id: "invoice.notPaid",
              defaultMessage: "Faktura nebyla prozatím zaplacena",
            })}
          />
        ),
    },
    {
      key: "code",
      title: intl.formatMessage({
        id: "invoice.code",
        defaultMessage: "Číslo",
      }),
      dataIndex: "code",
    },
    {
      key: "issueDate",
      title: intl.formatMessage({
        id: "invoice.issueDate",
        defaultMessage: "Datum vystavení",
      }),
      dataIndex: "issueDate",
    },
    {
      key: "taxableDate",
      title: intl.formatMessage({
        id: "invoice.taxableDate",
        defaultMessage: "Datum zdanitelného plnění",
      }),
      dataIndex: "taxableDate",
    },
    {
      key: "dueDate",
      title: intl.formatMessage({
        id: "invoice.dueDate",
        defaultMessage: "Datum splatnosti",
      }),
      dataIndex: "dueDate",
    },
    {
      key: "payDate",
      title: intl.formatMessage({
        id: "invoice.payDate",
        defaultMessage: "Datum úhrady",
      }),
      dataIndex: "payDate",
    },
    {
      key: "daysAfterDueDate",
      title: intl.formatMessage({
        id: "invoice.daysAfterDueDate",
        defaultMessage: "Počet dnů po splatnosti",
      }),
      dataIndex: "daysAfterDueDate",
      render: (_, i) =>
        i.state !== "CA" &&
        i.state !== "CN" &&
        i.daysAfterDueDate &&
        (!i.payDate || i.payDate === "--") ? (
          <Tooltip
            title={intl.formatMessage({
              id: "invoice.notPaidAndAfterDueDate",
              defaultMessage: "Faktura není zaplacena a je již po splatnosti",
            })}
          >
            <Text strong type="danger">
              {i.daysAfterDueDate}
            </Text>
          </Tooltip>
        ) : (
          <Text>{i.daysAfterDueDate || "--"}</Text>
        ),
    },
    {
      key: "amount",
      title: intl.formatMessage({
        id: "invoice.amount",
        defaultMessage: "Částka",
      }),
      dataIndex: "amount",
    },
  ];

  return (
    <LoadTable
      what={intl.formatMessage({
        id: "invoice.what",
        defaultMessage: "faktur",
      })}
      columns={columns}
      values={invoices}
      className="no-pointer"
      onLoadValues={loadInvoices}
      selectedRows={selectedInvoices}
      emptyText={intl.formatMessage({
        id: "invoice.noInvoices",
        defaultMessage: "žádné dostupné faktury",
      })}
      setSelectedRows={setSelectedInvoices}
    />
  );
}

export default InvoiceListTable;
